<template>
    <div id="asset_group_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vehicleStandaradAssetHeader" v-if="$route.params.id > 0">Update Standard Feature Configuration</span>
                    <span class="page-title" id="vehicleStandaradAssetHeader" v-else-if="already_added == true">Update Standard Feature Configuration</span>
                    <span class="page-title" id="vehicleStandaradAssetHeader" v-else>Add Standard Feature Configuration</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="AssetStandardFeaturesList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content stdfeature-config-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="VehicleStandardFeatureForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="model_year">Model year:</label>
                                        <input type="text" class="form-control" v-model="model_year" id="model_year" placeholder="Enter Model Year" name="model_year" v-on:change="loadCategories()" @keypress="isIntegerCheck($event)">
                                        <div class="field-error">{{model_year_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="vehicle_manufacturer_id">Manufacturer:</label>
                                        <v-select v-model="vehicle_manufacturer_id" name="vehicle_manufacturer_id" id="vehicle_manufacturer_id" label="text" :filterable="false" :options="vehicleManufacturerArr" @search="onSearchManufacturer" placeholder="Select Manufacturer" class='custom-ci-auto-search close-remove'>
                                            <template slot="no-options">
                                                Search Manufacturer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{vehicle_manufacturer_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="vehicle_model_id">Model:</label>
                                        <v-select v-model="vehicle_model_id" name="vehicle_model_id" placeholder="Select Model."
                                                    label="text"
                                                    :options="modelcodeArr" id="vehicle_model_id" v-on:change="loadCategories()" >
                                        </v-select>
                                        <div class="field-error">{{model_code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="vehicle_type_code">Asset Type:</label>
                                        <v-select v-model="vehicle_type_code" name="vehicle_type_code" placeholder="Select Asset Type."
                                                    label="text"
                                                    :options="vehicletypecodeArr" id="vehicle_type_code" v-on:change="loadCategories()">
                                        </v-select>
                                        <div class="field-error">{{vehicle_type_error_msg}}</div>
                                    </div>
                                </div>
                                <template v-if="already_added === true">
                                    <div class="alert alert-warning offset-sm-2 col-sm-6 err-msg" id="alertError" >
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error">You have already added this Feature. Please Update it</strong>
                                    </div>
                                </template>
                                <template v-if="assetFeatureCategoryAll != null">
                                    <template v-for="(category,key) in assetFeatureCategoryAll">
                                        <h6 :key="key" class="color-blue mt-2">{{category.category_name}}</h6>
                                        <div :key="key" class="form-row row-cols-md-1 row-cols-1">
                                            <div  class="col form-group">
                                                <v-select
                                                        class="multiselect"
                                                        v-model="categoryFeatures[category.id]"
                                                        :options="category.category_features"
                                                        :close-on-select="true"
                                                        :show-labels="true"
                                                        :multiple="true"
                                                        :searchable="true"
                                                        track-by="id"
                                                        label="feature_name"
                                                        placeholder="Please Select Feature"
                                                >
                                                </v-select>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                                <div class="field-error">{{ common_error_msg }}</div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <template v-if="already_added == true">
                                        <button type="submit" id="createVehicleStandardFeatureBtn" class="btn btn-primary" v-on:click.prevent="CreateVehicleStandardFeature">
                                        <i class="fp-reload"> </i>  Update
                                        </button>
                                        <button type="submit" id="cancelVehicleFeatureBtn" class="btn btn-tertiary" v-on:click.prevent="AssetStandardFeaturesList">
                                        <i class="fp-close"> </i>  Cancel
                                        </button>
                                    </template>
                                    <template v-if="already_added == false">
                                        <button type="submit" v-if="$route.params.id > 0" id="createVehicleStandardFeatureBtn" class="btn btn-primary" v-on:click.prevent="CreateVehicleStandardFeature" >
                                        <i class="fp-reload"> </i>  Update
                                        </button>

                                        <button type="submit" v-else id="createVehicleStandardFeatureBtn" class="btn btn-primary" v-on:click.prevent="CreateVehicleStandardFeature" >
                                        <i class="fp-save"> </i>  Save
                                        </button>

                                        <button type="submit" v-if="$route.params.id == undefined" id="createAndContinueVehicleFeatureBtn" class="btn btn-tertiary" v-on:click.prevent="CreateVehicleStandardFeature(flag='Save and Continue')" >
                                        <i class="fp-save-continue"> </i>  Save and Continue
                                        </button>

                                        <button type="submit" id="cancelVehicleFeatureBtn" class="btn btn-tertiary" v-on:click.prevent="AssetStandardFeaturesList" >
                                        <i class="fp-close"> </i>  Cancel
                                        </button>
                                    </template>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";

    import {commonMixins} from '../mixins/commonMixins';





    export default {
        name: "AssetStandardFeaturesCreate",
        mixins:[commonMixins],
        metaInfo() {
            return {title: (this.$route.params.id > 0)? "Update Asset Standard Feature | " +process.env.COPYRIGHT_NAME : "Create Asset Standard Feature | " +process.env.COPYRIGHT_NAME}
        },
        data: () => ({
            isEdit:false,
            permissions: [],
            cantAccessPage: "",
            model_year: "",
            vehicle_model_id: null,
            modelcodeArr: [],
            assetFeatureCategoryAll:[],
            assetFeatures:[],
            vehicle_type_code: null,
            vehicletypecodeArr: [],
            loading:false,
            model_year_error_msg: "",
            vehicle_type_error_msg : "",
            model_code_error_msg: "",
            sectionratesArr: [],
            code: "",
            code_error_msg:"",
            name:"",
            name_error_msg:"",
            common_error_msg:"",
            already_added:false,
            category:{
                vehicle_id:'',
                category_features:[]
            },
            categoryFeatures:[],
            already_stnd_id:'',
            vehicleManufacturerArr:[],
            vehicle_manufacturer_id:null,
            vehicle_manufacturer_error_msg:"",
            searcManufacturer:false,
        }),
        watch: {

            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_asset_standard_feature') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            },
            vehicle_manufacturer_id: function(vehicle_manufacturer_id) {

                var self = this;

                if(self.vehicle_manufacturer_id == null || self.vehicle_manufacturer_id == ""){
                    self.vehicle_model_id = null;
                    self.modelcodeArr = [];
                    return;
                }

                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/assetmodel/search",
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType:"json",
                    data:{
                        id:self.vehicle_manufacturer_id.value,
                    },
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {

                            if ( self.searcManufacturer ){
                                self.vehicle_model_id = null;
                            }
                            self.modelcodeArr = data.content.vehiclemodels;
                        }else{

                            if ( self.searcManufacturer ){
                                self.vehicle_model_id = null;
                            }
                            self.modelcodeArr = [];
                        }
                        self.searcManufacturer = false;
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server cannot be reached";
                        } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");

                            self.$router.push("/");
                        }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            // self.statusValue = 1;
            self.getPermissions();
            self.loadVehicleType();
            // self.loadVehicleModel();
            self.AssetFeatureCategoryAll();

            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {

                self.loadVehicleStandardFeatures();
            }
            // self.loadStandardFeatureData();
        },
        methods: {

            loadCategories(){
                var self = this;
                if(self.vehicle_model_id == null || self.vehicle_type_code == null){
                    return;
                }

               if((self.vehicle_model_id.value !=null && self.vehicle_type_code.value !=null && self.model_year !== '') && (self.vehicle_model_id !=null && self.vehicle_type_code !=null && self.model_year !== ''))
               {
                   // alert('if');
                   self.loading = true;
                   $.ajax({
                       url: process.env.ROOT_API + "/assetstandardfeatures/find-by-model-year-type",
                       type: "POST",
                       headers: this.ajxHeaders,
                       data: {'model_year':self.model_year,'vehicle_type_code':self.vehicle_type_code.value,'vehicle_model_id':self.vehicle_model_id.value},
                       crossDomain: true,
                       dataType: "json",
                       success: function (data) {
                           self.loading = false;
                        //    console.log(data);

                           if (data.status == "success") {
                                var path = window.location.pathname;
                                    var segments = path.split("/");

                                if (segments[3]) {
                                    self.already_added = false;
                                    self.already_stnd_id = data.content.id;
                                }else{
                                    self.already_added = true;
                                    self.already_stnd_id = data.content.id;
                                }
                               self.categoryFeatures = [];
                               if(data.content.feature.length > 0){
                                   for(var i=0;i<data.content.feature.length;i++){
                                       var catId = data.content.feature[i].id;
                                       self.categoryFeatures[catId] = data.content.feature[i].category_features;
                                   }
                               }


                           }
                           if (data.status == "add") {
                               self.already_added = false;
                               // self.AssetFeatureCategoryAll();
                               self.categoryFeatures = [];
                           }

                       },
                       error: function (jqXHR, exception) {
                           self.generateStatusCodeMessage(jqXHR,true,'std-feature-by-myt')
                       }
                   });
                   // self.AssetFeatureCategoryAll();
               }else{
                   // self.assetFeatureCategoryAll=[];
               }


            },

            addLine ($event, catId, feature) {
                var featureLength = this.assetFeatures[catId].length;
                // console.log(featureLength);
                if ( this.assetFeatures[catId][featureLength - 1].code == "" || this.assetFeatures[catId][featureLength - 1].code == null) {
                    this.assetFeatures[catId][featureLength - 1].codeError = "Code Required.";
                }

                if ( this.assetFeatures[catId][featureLength - 1].name == "" || this.assetFeatures[catId][featureLength - 1].name == null) {
                    this.assetFeatures[catId][featureLength - 1].nameError = "Name Required.";
                }

                if( this.assetFeatures[catId][featureLength - 1].code != "" && this.assetFeatures[catId][featureLength - 1].name != "" ){
                    this.assetFeatures[catId][featureLength - 1].codeError = "";
                    this.assetFeatures[catId][featureLength - 1].nameError = "";
                    this.$set(this.assetFeatures[catId],feature.length,{id:"",catId:catId,catName:feature[0].catName,name:'',code:'',weightFront:'',weightRear:'',nameError:"",codeError:""});

                }
            },

            removeLine ($event, catInd, feature,feInd) {
                if(feature.length > 1 && feInd >0)
                {
                    this.$delete(this.assetFeatures[catInd],feInd);
                }
            },
            AssetStandardFeaturesList() {
                var self = this;
                self.$router.push("/assetstandardfeature/list");
            },

            AssetFeatureCategoryAll(){

                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/assetfeaturecategory/search",
                    type: "POST",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType: "json",
                    success: function (data) {

                        if (data.status == "success") {
                            /*if ( data.content.length > 0 ) {
                                for( var i=0; i<data.content.length;i++) {

                                    self.$set(self.assetFeatures,data.content[i].id,[]);
                                    self.$set(self.assetFeatures[data.content[i].id],0,{
                                                                                        id:"",categoryId:data.content[i].id,
                                                                                        categoryName:data.content[i].name,name:'',
                                                                                        code:'',weightFront:'',weightRear:'',
                                                                                        nameError:"",codeError:""
                                                                                        })
                                    // self.$set(self.assetFeatures[data.content[i].id],1,{id:"",categoryId:data.content[i].id,categoryName:data.content[i].name,name:'',code:'',weightFront:'',weightRear:''})
                                }
                                console.log(self.assetFeatures);
                            }*/
                            self.assetFeatureCategoryAll = data.content;
                            // self.catData.catFeatures = data.content.category_features;
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR,true,'std-feature-asset-cat')
                    }
                });

            },

            loadVehicleModel() {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/assetmodels/getallmodel",
                    type: "GET",
                    dataType:"json",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    success: function (data) {

                        if (data.status == "success") {
                            self.modelcodeArr = data.content.vehiclemodels;
                            // console.log(self.modelcodeArr);
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'std-feature-get-all-model')
                    }
                });
            },


            loadVehicleType() {

                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/assettype/search",
                    type: "GET",
                    dataType:"json",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    success: function (data) {
                        // console.log(data);
                        // if (data.status == "success") {

                            self.vehicletypecodeArr = data;
                        // }

                    },
                    error: function (jqXHR, exception) {
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'std-feature-asset-type')
                    }
                });
            },
            checkSelected: function(e) {
                var self = this;
                if (e.target.checked) {

                    self.statusValue = 1;
                }else{
                    self.statusValue = 0;
                }
            },
            CreateVehicleStandardFeature(flag) {
                var self = this;
                var error = false;


                self.model_year_error_msg = "";
                self.vehicle_type_error_msg = "";
                self.model_code_error_msg = "";
                self.common_error_msg = "";
                self.vehicle_manufacturer_error_msg = "";

                if (!self.model_year || self.model_year == null || self.model_year == "") {
                    self.model_year_error_msg = "Model year Required.";
                    error = true;

                }
                if (!self.vehicle_manufacturer_id || self.vehicle_manufacturer_id == null || self.vehicle_manufacturer_id == "") {
                    self.vehicle_manufacturer_error_msg = "Asset Manufacturer Required.";
                    error = true;

                }
                if (!self.vehicle_model_id || self.vehicle_model_id == null || self.vehicle_model_id == "") {
                    self.model_code_error_msg = "Asset Model Required.";
                    error = true;

                }
                if (!self.vehicle_type_code || self.vehicle_type_code == null || self.vehicle_type_code == "") {
                    self.vehicle_type_error_msg = "Asset Type Required.";
                    error = true;

                }
                if(self.categoryFeatures.length < 1){
                    self.common_error_msg = "Please Select Feature.";
                    error = true;
                }
                var featuresArray = []; /*featuresArray with selected feature id */
                for(var i=0;i<self.categoryFeatures.length;i++){
                    if( self.categoryFeatures[i] != undefined){
                        for(var j=0;j<self.categoryFeatures[i].length;j++){
                            if(self.categoryFeatures[i].length > 0){
                                featuresArray.push(self.categoryFeatures[i][j].id);
                            }
                        }
                    }
                }

                /*if any feature is not selected */
                if(featuresArray.length < 1){
                    self.common_error_msg = "Please Select Feature."
                    error = true;
                }


                if (!error) {
                    self.loading = true;
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    if (segments[3])
                    {
                        $("#createVehicleStandardFeatureBtn").val("Updating ...");
                        $("#createVehicleStandardFeatureBtn").prop("disabled", true);
                        $("#cancelVehicleFeatureBtn").prop("disabled",true);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueVehicleFeatureBtn").val("Saving ...");
                            $("#createVehicleStandardFeatureBtn").prop("disabled", true);
                            $("#createAndContinueVehicleFeatureBtn").prop("disabled", true);
                            $("#cancelVehicleFeatureBtn").prop("disabled",true);

                        } else{

                            $("#createVehicleStandardFeatureBtn").val("Saving ...");
                            $("#createVehicleStandardFeatureBtn").prop("disabled", true);
                            $("#createAndContinueVehicleFeatureBtn").prop("disabled", true);
                            $("#cancelVehicleFeatureBtn").prop("disabled",true);
                        }
                    }

                    var fields = $("#VehicleStandardFeatureForm").serializeArray();
                    fields.push({name: "vehicle_manufacturer_id", value: self.vehicle_manufacturer_id.value});
                    //var formData = new FormData();
                    if(self.vehicle_model_id == null){
                        //formData.append('vehicle_model_id',"");
                         fields.push({name: "vehicle_model_id", value: ""});
                    }else{
                        //formData.append('vehicle_model_id',self.vehicle_model_id.value);
                        fields.push({name: "vehicle_model_id", value: self.vehicle_model_id.value});
                    }

                    if(self.vehicle_type_code == null){
                        //formData.append('vehicle_type_id',"");
                        fields.push({name: "vehicle_type_id", value: ""});
                    }else{
                        //formData.append('vehicle_type_id',self.vehicle_type_code.value);
                        fields.push({name: "vehicle_type_id", value: self.vehicle_type_code.value});
                    }

                    if(self.model_year != null){
                        //formData.append('model_year',self.model_year);
                         fields.push({name: "model_year", value: self.model_year});
                    }
                        fields.push({name: "features", value:JSON.stringify(self.categoryFeatures)});
                    //formData.append('standard_item',self.assetFeatures  );
                    if(self.already_stnd_id)
                    {
                        fields.push({ name: "id", value: self.already_stnd_id });
                    }else{
                        fields.push({ name: "id", value: segments[3] });
                    }
                    //formData.append('id',segments[3]);

                    // console.log(JSON.stringify(self.categoryFeatures));

                    $.ajax({
                        url: process.env.ROOT_API + "/assetstandardfeatures/create",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,

                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (segments[3])
                            {
                                $("#createVehicleStandardFeatureBtn").val("Update");
                                $("#createVehicleStandardFeatureBtn").prop("disabled", false);
                                $("#cancelVehicleFeatureBtn").prop("disabled",false);
                            } else {
                                if (flag == "Save and Continue") {

                                    $("#createAndContinueVehicleFeatureBtn").val("Save and Continue");
                                    $("#createVehicleStandardFeatureBtn").prop("disabled", false);
                                    $("#createAndContinueVehicleFeatureBtn").prop("disabled", false);
                                    $("#cancelVehicleFeatureBtn").prop("disabled",false);

                                } else{

                                    $("#createVehicleStandardFeatureBtn").val("Save");
                                    $("#createVehicleStandardFeatureBtn").prop("disabled", false);
                                    $("#createAndContinueVehicleFeatureBtn").prop("disabled", false);
                                    $("#cancelVehicleFeatureBtn").prop("disabled",false);

                                }
                            }
                            if (data.status == "success") {

                                if (flag == "Save and Continue") {

                                    $("#VehicleGroupForm").trigger("reset");

                                    self.model_year = "";
                                    self.vehicle_manufacturer_id = null;
                                    self.vehicle_model_id = null;
                                    // self.modelcodeArr = "";
                                    self.vehicle_type_code = null;
                                    // self.vehicletypecodeArr = "";
                                    self.categoryFeatures = [];
                                    self.alrery_added=false;

                                } else{
                                    self.$router.push("/assetstandardfeature/list");
                                }

                            } else {
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }
                                    $("#errorMsg").html(err);
                                    $(".alert-warning").toggleClass("show");
                                    setTimeout(function () {
                                        $(".alert-warning").removeClass("show");
                                        $(".alert-warning").addClass("hide");
                                    }, 10000);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (segments[3])
                            {
                                $("#createVehicleStandardFeatureBtn").val("Update");
                                $("#createVehicleStandardFeatureBtn").prop("disabled", false);
                                $("#cancelVehicleFeatureBtn").prop("disabled",false);
                            } else {
                                if (flag == "Save and Continue") {

                                    $("#VehicleGroupForm").trigger("reset");
                                    $("#createAndContinueVehicleFeatureBtn").val("Save and Continue");
                                    $("#createVehicleStandardFeatureBtn").prop("disabled", false);
                                    $("#createAndContinueVehicleFeatureBtn").prop("disabled", false);
                                    $("#cancelVehicleFeatureBtn").prop("disabled",false);

                                } else{

                                    $("#createVehicleStandardFeatureBtn").val("Save");
                                    $("#createVehicleStandardFeatureBtn").prop("disabled", false);
                                    $("#createAndContinueVehicleFeatureBtn").prop("disabled", false);
                                    $("#cancelVehicleFeatureBtn").prop("disabled",false);

                                }
                            }
                            self.generateStatusCodeMessage(jqXHR,true,'std-feature-create')
                        }
                    });
                }else{
                    self.errorValidationFocus();
                }

            },

            loadVehicleStandardFeatures() {

                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/assetstandardfeatures/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                            // console.log(data);
                        self.loading = false;
                        if (data.status == "success") {
                            self.isEdit = true;
                            self.model_year = data.content.model_year;

                            if(data.content.vehicle_manufacturer_id == null) {
                                self.vehicle_manufacturer_id = null;
                            }else{
                                self.vehicle_manufacturer_id = {value: data.content.vehicle_manufacturer_id, text: self.titleCase(data.content.vmCode) + " | " + self.titleCase(data.content.vmName)};
                            }

                            if(data.content.vehicle_model_id == null) {
                                self.vehicle_model_id = null;
                            }else{
                                self.vehicle_model_id = {value: data.content.vehicle_model_id, text: self.titleCase(data.content.vmodelsName + " (" + data.content.vmodelsCode +")")};
                            }

                            if(data.content.vehicle_type_id == null) {
                                self.vehicle_type_code = null;
                            }else{
                                self.vehicle_type_code = {value: data.content.vehicle_type_id, text: self.titleCase(data.content.vtName + " (" + data.content.vtCode +")")};
                            }
                            // self.categoryFeatures = [];


                            self.categoryFeatures = [];
                            if(data.content.feature.length > 0){
                                for(var i=0;i<data.content.feature.length;i++){
                                    var catId = data.content.feature[i].id;
                                    self.categoryFeatures[catId] = data.content.feature[i].category_features;
                                }
                            }


                        }
                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'std-feature-load-by-id')
                    }
                });
            },


            titleCase(str) {
                if (str == null){
                    return;
                } else{
                    var value = str.toString()
                    return value.charAt(0).toUpperCase() + value.slice(1)
                }
            },
            onSearchManufacturer(search, loading) {
                var self = this;
                if (search.length > 2) {
                    self.searcManufacturer = true;
                    loading(true);
                    self.searchField(loading, search, 'vehicle_manufacturer', '');
                }
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/AssetStandardFeaturesCreate.vue